import { Heading1, AlignLeft, Image as ImageIcon, MousePointerClick, Minus, MoveVertical, Columns2 } from "lucide-react";

export const BLOCK_TYPES = [
  { type: "heading", label: "Heading", icon: Heading1, props: { text: "Your headline here", align: "left", size: "md" } },
  { type: "text", label: "Text", icon: AlignLeft, props: { text: "Hi {{first_name}},\n\nWrite your paragraph here. Blank line = new paragraph. Start lines with - for bullets.", align: "left" } },
  { type: "image", label: "Image", icon: ImageIcon, props: { url: "", alt: "", width: 100, align: "center", link: "" } },
  { type: "button", label: "Button", icon: MousePointerClick, props: { label: "Book a call", url: "", align: "left" } },
  { type: "divider", label: "Divider", icon: Minus, props: {} },
  { type: "spacer", label: "Spacer", icon: MoveVertical, props: { height: 24 } },
  { type: "columns", label: "2 Columns", icon: Columns2, props: { cols: [{ kind: "text", text: "Left column" }, { kind: "text", text: "Right column" }] } },
];

export const newBlock = (type) => {
  const def = BLOCK_TYPES.find((b) => b.type === type);
  return { id: `b${Date.now().toString(36)}${Math.random().toString(36).slice(2, 6)}`, type, props: JSON.parse(JSON.stringify(def.props)), style: {} };
};

export const SIDES = [["t", "Top"], ["r", "Right"], ["b", "Bottom"], ["l", "Left"]];
export const boxCss = (st = {}) => ({
  padding: `${st.pt || 0}px ${st.pr || 0}px ${st.pb || 0}px ${st.pl || 0}px`,
  margin: `${st.mt || 0}px ${st.mr || 0}px ${st.mb || 0}px ${st.ml || 0}px`,
  position: "relative",
  zIndex: st.z || undefined,
  background: st.bg || undefined,
  border: st.bw ? `${st.bw}px solid ${st.bc || "#E5E7EB"}` : undefined,
  borderRadius: st.radius ? `${st.radius}px` : undefined,
});

// classic headline/body/cta → blocks
export const classicToBlocks = (s) => {
  const out = [];
  if (s.headline) out.push({ ...newBlock("heading"), props: { text: s.headline, align: "left", size: "md" } });
  out.push({ ...newBlock("text"), props: { text: s.body || "", align: "left" } });
  if (s.cta_label) out.push({ ...newBlock("button"), props: { label: s.cta_label, url: s.cta_url || "", align: "left" } });
  return out;
};
